import React from "react";
import { inject, observer } from "mobx-react";
import Store from "../../stores/NewExistingOwnerStore";
import { PageViews } from "../../models/NewExistingOwner";
import { Intro, FindCar, Details, Thanks, Notify } from "./";
import Loader from "../../components/Loader";
import { PopupModal } from "../Modals";

interface IProps {
  store?: Store;
}
interface IState {}

@inject("store")
@observer
class NewExistingOwner extends React.Component<IProps, IState> {
  componentDidMount() {
    window['pushDigitalData']({
      "event": "_pageLoaded"
    });
  }

  render() {
    const { store } = this.props;
    const { activePage } = store;

    return (
      <div className="neo pageSection">
        {activePage === PageViews.Intro && <Intro />}
        {activePage === PageViews.FindCar && <FindCar />}
        {activePage === PageViews.Details && <Details />}
        {activePage === PageViews.Thanks && <Thanks />}
        <PopupModal />
        {store.notifications.map((item, index) => (
          <Notify onHide={() => store.removeNotification(item.id)} data={item} position={index} key={item.id} />
        ))}
        <Loader isLoading={store.isLoading} isPositionRelative={true} />
      </div>
    );
  }
}

export default NewExistingOwner;
